/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type SelectDKContestQueryVariables = {||};
export type SelectDKContestQueryResponse = {|
  +whoAmI: ?{|
    +username: string,
    +groups: $ReadOnlyArray<{|
      +name: string
    |}>,
  |},
  +activeContests: ?$ReadOnlyArray<?{|
    +id: string,
    +contestId: number,
    +name: string,
  |}>,
|};
export type SelectDKContestQuery = {|
  variables: SelectDKContestQueryVariables,
  response: SelectDKContestQueryResponse,
|};
*/


/*
query SelectDKContestQuery {
  whoAmI {
    username
    groups {
      name
    }
    id
  }
  activeContests {
    id
    contestId
    name
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "username",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "GroupType",
  "kind": "LinkedField",
  "name": "groups",
  "plural": true,
  "selections": [
    (v1/*: any*/)
  ],
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "DraftKingsContestType",
  "kind": "LinkedField",
  "name": "activeContests",
  "plural": true,
  "selections": [
    (v3/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "contestId",
      "storageKey": null
    },
    (v1/*: any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "SelectDKContestQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "UserType",
        "kind": "LinkedField",
        "name": "whoAmI",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v2/*: any*/)
        ],
        "storageKey": null
      },
      (v4/*: any*/)
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "SelectDKContestQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "UserType",
        "kind": "LinkedField",
        "name": "whoAmI",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v2/*: any*/),
          (v3/*: any*/)
        ],
        "storageKey": null
      },
      (v4/*: any*/)
    ]
  },
  "params": {
    "cacheID": "666ceedfb4b2d43a83f61acbbd0e668c",
    "id": null,
    "metadata": {},
    "name": "SelectDKContestQuery",
    "operationKind": "query",
    "text": "query SelectDKContestQuery {\n  whoAmI {\n    username\n    groups {\n      name\n    }\n    id\n  }\n  activeContests {\n    id\n    contestId\n    name\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'f3b1b2f50f928143e8fc1c3b020fc311';

module.exports = node;
